// extracted by mini-css-extract-plugin
export var bigTitle = "video-opinions-module--big-title--HdRkm";
export var playIcon = "video-opinions-module--playIcon--AHfV-";
export var playText = "video-opinions-module--playText--CkbmP";
export var subtitle = "video-opinions-module--subtitle--1HwBp";
export var title = "video-opinions-module--title--gX1U5";
export var videoList = "video-opinions-module--videoList--1dMWH";